import { render, staticRenderFns } from "./caseReport.vue?vue&type=template&id=73317340&scoped=true&"
import script from "./caseReport.vue?vue&type=script&lang=js&"
export * from "./caseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73317340",
  null
  
)

export default component.exports